import routes from './routes';
import { SetRoutes } from 'components';

const FootfallsPages = () => {
    return (
        <>
            <SetRoutes routes={routes} />
        </>
    );
};

export default FootfallsPages;
